"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DialogMain = exports.Main = exports.DialogContent = exports.Dialog = void 0;

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var types = _interopRequireWildcard(require("../../types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function slideIn(slideInTransform, slideOutTransform) {
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], slideOutTransform, slideInTransform);
}

function slideOut(slideInTransform, slideOutTransform) {
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], slideInTransform, slideOutTransform);
}

function getSlideOutTransform(slideFrom) {
  switch (slideFrom) {
    case types.slideFroms.LEFT:
      return "translateX(-100%)";

    case types.slideFroms.RIGHT:
      return "translateX(100%)";

    case types.slideFroms.BOTTOM:
      return "translateY(100%)";

    default:
      return null;
  }
}

function getSlideInTransform(slideFrom) {
  switch (slideFrom) {
    case types.slideFroms.LEFT:
    case types.slideFroms.RIGHT:
      return "translateX(0)";

    case types.slideFroms.BOTTOM:
      return "translateY(0)";

    default:
      return null;
  }
}

function getWidth(width) {
  var result = "";

  if ((0, _isNan["default"])(Number(width))) {
    switch (width) {
      case types.widthTypes.SMALL:
        result = "350px";
        break;

      case types.widthTypes.MEDIUM:
        result = "420px";
        break;

      case types.widthTypes.LARGE:
        result = "640px";
        break;

      default:
        result = width;
        break;
    }
  } else {
    result = "".concat(width, "px");
  }

  return result;
}

var Dialog = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__Dialog",
  componentId: "sc-aynya2-0"
})(function (_ref) {
  var hasPushedElement = _ref.hasPushedElement,
      height = _ref.height,
      isAnimating = _ref.isAnimating,
      isInline = _ref.isInline,
      isOpen = _ref.isOpen,
      offset = _ref.offset,
      slideFrom = _ref.slideFrom,
      width = _ref.width,
      zIndex = _ref.zIndex;
  var slideOutTransform = getSlideOutTransform(slideFrom);
  var slideInTransform = getSlideInTransform(slideFrom);
  var calculatedHeight = null;
  var calculatedWidth = null;
  var left = null;
  var right = null;
  var top = null;
  var bottom = null;
  var borderTop = null;

  switch (slideFrom) {
    case types.slideFroms.LEFT:
    case types.slideFroms.RIGHT:
      calculatedHeight = offset.top ? "calc(100% - ".concat(offset.top, "px);") : "100%";
      calculatedWidth = getWidth(width);
      left = slideFrom === types.slideFroms.LEFT ? 0 : null;
      right = slideFrom === types.slideFroms.RIGHT ? 0 : null;
      top = "".concat(offset.top, "px");
      break;

    case types.slideFroms.BOTTOM:
      calculatedHeight = (0, _isNan["default"])(Number(height)) ? height : "".concat(height, "px");
      calculatedWidth = "calc(100% - ".concat(offset.left, "px - ").concat(offset.right, "px)");
      left = "".concat(offset.left, "px");
      right = "".concat(offset.right, "px");
      bottom = 0;
      break;

    default:
  }

  var animationStyle = isAnimating ? (0, _styledComponents.css)(["animation:", " 0.4s forwards;"], isOpen ? slideIn(slideInTransform, slideOutTransform) : slideOut(slideInTransform, slideOutTransform)) : "";
  var boxShadow = hasPushedElement ? "none" : "0 12px 24px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.16)";
  return (0, _styledComponents.css)(["", ";background:", ";border:0;border-top:", ";bottom:", ";box-shadow:", ";box-sizing:border-box;display:flex;flex-direction:column;height:", ";left:", ";margin:0;overflow:auto;padding:0;", " right:", ";top:", ";width:", ";z-index:", ";&:focus{outline:0;}"], animationStyle, _tokens["default"].color.white, borderTop, bottom, boxShadow, calculatedHeight, left, isInline ? "position: relative;" : "position: fixed;", right, top, calculatedWidth, zIndex);
});

exports.Dialog = Dialog;

var DialogContent = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__DialogContent",
  componentId: "sc-aynya2-1"
})(function (_ref2) {
  var hasPushedElement = _ref2.hasPushedElement,
      slideFrom = _ref2.slideFrom;
  return (0, _styledComponents.css)(["flex-grow:1;margin:0;padding:0;&:focus{", ";}", " ", ""], _stylers["default"].focusRing.subtle(true), hasPushedElement && slideFrom === types.slideFroms.LEFT ? "border-right: 1px solid ".concat(_tokens["default"].border.color) : "", hasPushedElement && slideFrom === types.slideFroms.RIGHT ? "border-left: 1px solid ".concat(_tokens["default"].border.color) : "");
});

exports.DialogContent = DialogContent;

var Main = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__Main",
  componentId: "sc-aynya2-2"
})(["display:flex;flex-direction:column;height:100%;position:relative;width:100%;"]);

exports.Main = Main;

var DialogMain = _styledComponents["default"].div.withConfig({
  displayName: "Dialogstyles__DialogMain",
  componentId: "sc-aynya2-3"
})(["flex-grow:1;overflow-y:auto;"]);

exports.DialogMain = DialogMain;
//# sourceMappingURL=Dialog.styles.js.map